import { configureStore, combineReducers, getDefaultMiddleware } from '@reduxjs/toolkit'
import authenticationReducer from './authenticationSlice'
import storage from 'redux-persist/lib/storage';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    persistStore,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import flashMessages from './flashMessages';

const rootReducer = combineReducers({
    authentication: authenticationReducer,
    flash: flashMessages
})

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    whitelist: ['authentication']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
})

export const persistor = persistStore(store);